<template>
  <div class="container">
    <div class="p-booking__inner-wrapper">
      <div class="p-booking__title pt-4">
        {{ dictionary.chooseSeats }}
      </div>
      <div class="p-booking__seats-wrapper">
        <div class="p-booking__seats-choice">
          <Loader v-if="isLoading" />
          <Alert
            v-if="store.errorMsgs.length"
            type="danger"
            :messages="store.errorMsgs" />

          <Seats
            v-if="seatsPlan"
            :rows="seatsPlan.rows"
            :total-columns="seatsPlan.columnCount"
            @recall-seats="callSeatsPlan"
            @choose-seat="chooseSeat" />
        </div>
        <div class="p-booking__seat-types">
          <SeatsTypes :areas="areas" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  computed,
  getCurrentInstance,
  onBeforeMount,
  ref,
} from 'vue'
import Seats from '../../components/Booking/Step3/Seats.vue'
import SeatsTypes from '../../components/Booking/Step3/SeatsTypes.vue'
import Loader from '../../components/Shared/Loader.vue'
import Alert from '../../components/Shared/Alert.vue'
import { useBookingStore } from '../../store/BookingStore'
const store = useBookingStore()

const { dictionary } = getCurrentInstance().appContext.config.globalProperties

const isLoading = ref(false)

const seatsPlan = computed(() => store.getSeatsPlan)

onBeforeMount(async () => {
  await callSeatsPlan()
})

const areas = computed(() => {
  const uniqueAreaCategories = ref(new Map())

  seatsPlan.value?.rows.forEach((row) => {
    row.seats.forEach((seat) => {
      if (seat.areaCategoryCode) {
        const { areaCategory, areaCategoryCode, areaCategoryColor } = seat
        
        if (!uniqueAreaCategories.value.has(areaCategoryCode)) {
          // Add the object if it's not already in the map
          uniqueAreaCategories.value.set(areaCategoryCode, {
            areaCategoryCode,
            areaCategory,
            areaCategoryColor,
          })
        }
      }
    })
  })
  return uniqueAreaCategories.value
})

const callSeatsPlan = async () => {
  store.assignGlobalErrorMessages([])
  isLoading.value = true
  try {
    await store.getAllSeatsPlanToRender()
  } catch (error) {
    store.assignGlobalErrorMessages([error])
  }
  isLoading.value = false
}

const chooseSeat = async (seat) => {
  store.assignGlobalErrorMessages([])
  isLoading.value = true
  try {
    await store.chooseSeatHandler(seat)
  } catch (error) {
    store.assignGlobalErrorMessages([error])
  }
  isLoading.value = false
}
</script>
<style lang="scss" scoped>
.loader {
  position: fixed;
}
</style>
